export enum LogLevel {
  DEBUG = 'debug',
  INFO = 'info',
  WARN = 'warn',
  ERROR = 'error',
  CRITICAL = 'critical',
}

export interface LogEntry {
  level: LogLevel;
  message: string;
  timestamp: number;
  context?: string;
  data?: unknown;
  stackTrace?: string;
  userAgent?: string;
  url?: string;
}

export interface LogConfig {
  enableConsole: boolean;
  enableBackendTransport: boolean;
  enableLocalStorage: boolean;
  batchSize: number;
  batchInterval: number;
  maxLogs?: number;
  sensitiveKeys?: string[];
}
